import { addParams } from 'src/modules/utils/addParams'

/**
 * Generate VideoObject structured data for live preview pages
 * @param {Object} params - Configuration object
 * @param {string} params.networkName - Display name of the network (e.g., "FOX")
 * @param {string} params.callsign - Network callsign for stream URL (e.g., "FOX")
 * @param {string} params.logoUrl - URL to network logo for thumbnail
 * @param {string} params.slug - Page slug for embed URL (e.g., "fox")
 * @returns {Object} VideoObject structured data
 */
export function createVideoStructuredData({ networkName, callsign, logoUrl, slug }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: `Watch ${networkName} Live`,
    // TEMPORARY NBC DISPUTE
    // description: `Watch ${networkName} live with Fubo. Stream sports, news, and entertainment. 200+ channels including FOX, NBC, CBS, ESPN, and more.`,
    description: `Watch ${networkName} live with Fubo. Stream sports, news, and entertainment. 200+ channels including FOX, CBS, ESPN, and more.`,
    thumbnailUrl: [
      addParams(logoUrl, 'w=1280&h=720&fit=pad&bg=FFFFFF'),
      addParams(logoUrl, 'w=1920&h=1080&fit=pad&bg=FFFFFF'),
    ],
    uploadDate: '2024-01-01T00:00:00Z',
    duration: 'PT2M',
    contentUrl: `https://preview.fubo.tv/${callsign}/1.m3u8`,
    embedUrl: `https://www.fubo.tv/stream/live/preview/${slug}/`,
    publisher: {
      '@type': 'Organization',
      name: 'Fubo',
      logo: {
        '@type': 'ImageObject',
        url: 'https://assets-imgx.fubo.tv/marketing/lp/images/logos/Fubo_Primary_Logo_FC_RGB.png',
      },
    },
    potentialAction: {
      '@type': 'WatchAction',
      target: `https://preview.fubo.tv/${callsign}/1.m3u8`,
    },
    publication: {
      '@type': 'BroadcastEvent',
      isLiveBroadcast: true,
      startDate: '2024-01-01T00:00:00Z',
    },
  }
}
